import * as Yup from 'yup';
import { PERSON_TYPES } from '../constants/constants.js';

export const CreateValidationSchema = Yup.object({
  clientName: Yup.string().required('请输入逝者名字'),
  videoType: Yup.string().required('请选择视频标准'),
  ceremonyDate: Yup.string().required('请选择仪式日期'),
  status: Yup.string().required('请选择视频类型'),
  telephone: Yup.string()
    .matches(/^1[3-9]\d{9}$/, '请输入正确格式手机号')
    .required('请输入正确格式的主事人手机号'),
});

export const validate = (values) => {
  const errors = {};
  //逝者名字验证;
  if (!values.clientName) {
    errors.clientName = '逝者名字 是必填项';
  }

  // 视频标准验证
  if (!values.videoType) {
    errors.videoType = '视频标准 是必填项';
  }

  // 仪式时间验证
  if (!values.ceremonyDate) {
    errors.ceremonyDate = '仪式时间 是必填项';
  }

  // 是否使用视频验证
  if (values.useInCeremony === null) {
    errors.useInCeremony = '是否在仪式中使用视频 是必填项';
  }

  // 性别验证
  if (values.gender === null) {
    errors.gender = '逝者性别 是必填项';
  }

  if (!values.telephone) {
    errors.telephone = '主事人手机号是必填项';
  } else if (!/^1[3-9]\d{9}$/.test(values.telephone)) {
    errors.telephone = '请输入正确格式手机号';
  }

  if (!values.texts) {
    errors.texts = '逝者生平 是必填项';
  }

  // 第一人称/第三人称验证
  if (!values.firstOrThirdPerson) {
    errors.firstOrThirdPerson = '请选择第一人称或第三人称';
  }

  // 如果是第三人称，验证讲述者与逝者关系
  if (values.firstOrThirdPerson === PERSON_TYPES.THIRD_PERSON && !values.relationship) {
    errors.relationship = '讲述者与逝者关系 是必填项';
  }

  if (values.images.length === 0) {
    errors.images = '逝者照片 是必填项';
  } else {
    const hasEmptySortOrder = values.images.some(
      (img) => img.sort_order === '' || img.sort_order === null || img.sort_order === undefined
    );
    if (hasEmptySortOrder) {
      errors.images = '所有图片的排序都不能为空';
    }
  }

  if (
    values.deceased_audio[0] &&
    (values.deceased_audio[0].description === '' ||
      values.deceased_audio[0].description === null)
  ) {
    errors.deceased_audio = '逝者声音文本 需要填写';
  }

  if (
    values.narrator_audio[0] &&
    (values.narrator_audio[0].description === '' ||
      values.narrator_audio[0].description === null)
  ) {
    errors.narrator_audio = '讲述者声音文本 需要填写';
  }

  return errors;
};
